export function dismissablePromise<T>(promise: Promise<T>,
                                      isDismissed: () => boolean): Promise<T> {
  return new Promise<T>((resolve, reject) => {
    promise.then(value => {
        if (!isDismissed())
          resolve(value);
      },
      (error) => {
        if (!isDismissed())
          reject(error);
      });
  });
}

export function dismissablePromiseLoader<T>(loader: () => Promise<T>,
                                            isDismissed: () => boolean): () => Promise<T> {
  return () => {
    if (isDismissed())
      return new Promise<T>(() => {
      });
    return dismissablePromise<T>(loader(), isDismissed);
  };
}

